<template>
  <div class="ui-content dashboard leader-sub">
    <div class="test-name-search complimenry-out-cp3 new-test-cp3-ui">
      <div class="show-drop-down">
        <div class="label-data">
          Center:
        </div>
        <div class="field-data">
          <multi-select
            allText="All Centers"
            :items="centers"
            ref="centerSelect"
            :onChange="onCenterchange"
            v-model="selectedCenterId"
            label="Center"
            hide-details
            dense
            outlined
            class="fix-200"
            filled
          ></multi-select>
        </div>
      </div>
      <div class="show-drop-down">
        <div class="label-data">
          Batch:
        </div>
        <div class="field-data">
          <multi-select
            allText="All Batches"
            :items="batches"
            ref="centerSelect"
            :onChange="onselectedBatch"
            label="Batch"
            hide-details
            dense
            outlined
            class="fix-200"
            filled
          ></multi-select>
        </div>
      </div>
      <div class="show-drop-down">
        <div class="label-data">
          Subject:
        </div>
        <div class="field-data">
          <v-select
            :items="subjects"
            v-model="selectedSubject"
            item-text="title"
            item-value="id"
            @change="onChangeSubject"
            hide-details
            dense
            outlined
            class="required"
          ></v-select>
        </div>
      </div>
      <div class="search-test-name complimenry-cp3">
        <v-text-field
          v-model="testName"
          @keydown.enter="onSearchTest()"
          solo
          label="Test Name"
          dense
          outlined
          hide-details
          append-icon="search"
          autocomplete="off"
        ></v-text-field>
      </div>
    </div>

    <div>
      <v-card class="mx-auto normal-card">
        <div class="data-table-section prev-test-tb cat-44">
          <v-data-table
            :headers="headers"
            fixed-header
            :items="items"
            hide-default-header
            hide-default-footer
            class="elevation-2 cust-table"
          >
            <template v-slot:header="{ props: { headers } }">
              <TableHeader
                :headers="headers"
                :onSortChange="onSortChange"
                :onHeaderAction="onHeaderAction"
                :orderBy="orderBy"
              />
            </template>
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.test_id">
                  <td
                    class="text-center rescheduletest"
                    @click="gotoPastTest(item)"
                  >
                    <v-tooltip left content-class="cust-new-tooltip-bottom">
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        {{ item.test_name }}
                      </div>
                    </template>
                    <span>
                      <b> Target Exam: </b> {{ item.target_name ? item.target_name : "Custom" }} <br/>
                      <b>Test Pattern: </b> {{ item.omr_pattern_id ? OMR_PATTERN[item.omr_pattern_id] : "Custom" }}
                    </span>
                  </v-tooltip>
                  </td>
                  <td class="text-center">
                    {{ item.duration }}
                  </td>
                  <td class="text-center">
                    {{ item.target_name }}
                  </td>
                  <td class="text-center">
                    <div class="date-ui">
                      {{ getFormatedDate(item.exam_date) }}
                    </div>
                    <!-- <div class="time-ui">{{ getFormatedTime(item.date_answered) }}</div> -->
                  </td>
                  <td class="text-center">
                    {{
                      item.subject &&
                      item.subject.subject_id &&
                      item.subject.subject_id === selectedSubject &&
                      item.subject.avg_sub_marks > 0
                        ? item.subject.avg_sub_marks
                        : ""
                    }}
                  </td>
                  <td class="text-center">
                    {{
                      item.subject &&
                      item.subject.subject_id &&
                      item.subject.subject_id === selectedSubject &&
                      item.subject.highest_marks > 0
                        ? item.subject.highest_marks
                        : ""
                    }}
                  </td>
                  <td class="text-center">
                    {{ (item.overall_average && item.overall_average) || "" }}
                  </td>
                  <td class="text-center">
                    {{ (item.overall_highest && item.overall_highest) || "" }}
                  </td>
                  <td class="text-center">
                    {{ item.avg_mark }}
                  </td>
                  <td class="download-icon">
                    <v-img class="loader-img" src="../../../assets/img/loading.gif" v-if="item.status == downloadStatus.IN_PROGRESS"
                    ></v-img>
                    <!-- <v-btn
                      v-else-if="item.status===downloadStatus.COMPLETED"
                      class="download-btn-cp3"
                      color="transparent"
                      depressed
                      @click="downloadTestURL(item)"
                    >1
                      <v-img
                        src="../../../assets/img/svg/download2.svg"
                      ></v-img>
                    </v-btn> -->
                    <v-btn
                      v-else
                      class="download-btn-cp3"
                      color="transparent"
                      depressed
                      @click="downloadTest(item)"
                    >
                      <v-img
                        width="23px"
                        src="../../../assets/img/download.svg"
                      ></v-img>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
          <div class="btm-test-prev-test">
            Click on a test name to revisit that test
          </div>
        </div>
      </v-card>
      <div class="footer-btn">
        <div class="pull-left"></div>
        <div class="pull-right">
          <Pagination
            :currentPage="currentPage"
            :totalPage="totalPages"
            :onPageChange="onPageChange"
          />
        </div>
      </div>
      <AlertBox
        :width="modalwidth"
        :onClose="onClose"
        :component="cComponent"
        :status="status"
        :data="alertBoxData"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment, { duration } from "moment";
import constants from "../../../utils/constants";

export default {
  name: "Past-Test-Teacher",
  mounted() {
    this.checkSessionData();
    this.OMR_PATTERN = constants.OMR_PATTERN;
  },
  data() {
    return {
      headers: [],
      items: [],
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      orderBy: {
        field: "exam_date",
        order: "DESC",
      },
      alertBoxData: null,
      cComponent: "",
      modalwidth: "",
      status: false,
      selectedExamTypes: [],
      subjects: [],
      teacherSubjectId: [],
      selectedSubject: {},
      centers: [],
      selectedCenterId: [],
      batches: [],
      selectedBatch: null,
      testName: "",

      downloadStatus:{},
      requestIds:[],
      testStatusTimeout: 0,
      toasts:{}
    };
  },
  computed: {
    ...mapState("userStore", ["user", "modules"]),
  },
  methods: {
    ...mapActions({
      getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
      getTestTarget: "utilStore/getTestTarget",
      getTeacherSubject: "userStore/getTeacherSubject",
      getPastTestList: "testStore/getPastTestTeacher",
      getCenters: "centerAndBatchStore/getCentersByUser",
      getBatches: "centerAndBatchStore/getBatches",
      downloadTestPaper: "testStore/downloadTest",
      deleteDownloadData: "testStore/deleteDownloadData",
      getDownloadStatus: "testStore/getDownloadStatus",
    }),
    defaultData() {
      this.downloadStatus = constants.DOWNLOAD_STATUS;
      this.requestGetCenters();
      this.getTeacherSubjectTree();
      this.checkDownloadUpdate()
      // this.reqGetTestTargets();
      // this.requestGetTestList();
    },
    checkSessionData() {
    //   this.addBreadCrumbChilde([]);
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);
        console.log(rp);
        
      if (rp.params.resetPage || !crd.routeName) {
        let tabDetail = {
          default: { page: 1, requestIds: [] },
        };
        let routeDetails = {
          routeName: rp.name,
          selectedTab: "default",
          tabDetails: tabDetail,
        };
        console.log(routeDetails);
        
        this.setRouteDetails(routeDetails);
      }
      this.defaultData();
    },
    getHeaders() {
      const headers = [
        {
          text: "Test Name",
          value: "test_name",
          class: "text-center",
          sortByNumber: 1,
        },
        {
          text: "Duration (Min)",
          value: "duration",
          class: "text-center",
          hideSort: true,
          sortByNumber: 2,
        },
        {
          text: "Target Exam",
          value: "target_exam",
          class: "text-center",
          sortByNumber: 3,
          hideSort: true,
        },
        {
          text: "Exam Date",
          value: "exam_date",
          class: "text-center",
          sortByNumber: 4,
        },
        {
          text:
            this.subjects.find((s) => s.id === this.selectedSubject).title +
            " Average",
          value:
            this.subjects.find((s) => s.id === this.selectedSubject).title +
            "_avg",
          class: "text-center",
          sortByNumber: 5,
          hideSort: true,
        },
        {
          text:
            this.subjects.find((s) => s.id === this.selectedSubject).title +
            " Highest",
          value:
            this.subjects.find((s) => s.id === this.selectedSubject).title +
            "_avg",
          class: "text-center",
          sortByNumber: 6,
          hideSort: true,
        },
        {
          text: "Overall Average",
          value: "highest_mark",
          class: "text-center",
          hideSort: true,
          sortByNumber: 19,
        },
        {
          text: "Overall Highest",
          value: "avg_mark",
          class: "text-center",
          hideSort: true,
          sortByNumber: 20,
        },
        {
          text: "",
          value: "",
          type: "blank",
          class: "dint-120",
          sortByNumber: 21,
        },
      ];

      this.headers = _.orderBy(headers, "sortByNumber", "asc");
    },
    downloadTest(item) {
      this.cComponent = "components/coordinator/Tests/DownloadTestPopup";
      this.alertBoxData = {
        ...item,
        isOnlineOfflineTest: this.isOfflineTestVisible(),
      };
      this.status = true;
      this.modalwidth = "570px";
    },
    isOfflineTestVisible() {
      const isOnline = this.modules
        ? this.modules.findIndex((m) => m.module_id === 9) > -1
        : "";
      const isOffline = this.modules
        ? this.modules.findIndex((m) => m.module_id === 13) > -1
        : "";
      return { isOffline, isOnline };
    },
    onClose(item) {
      this.status = item.status;
      if (item.action === "reloadTestList") {
        this.requestGetTestList();
      }
      if (item && item.data) {
        let domainUrl = process.env.VUE_APP_API_URL;
        let tab = "online";
        if (this.isOfflineTestVisible().isOffline) {
          tab = "offline";
        }
          if(window.location.href.includes('/past-test-institute')){
          console.log('in past test institute')
          tab = "offline";
        }
        let token = sessionStorage.getItem("auth_token");
        let api = "download-test";
        let query = `custom=${tab}&token=${token}&column=${item.isTwoColumn}&isRoughWork=${item.isRoughWork}&pageBreak=${item.pageBreak}&fontSize=${item.bodyFontSize}&fontFamily=${item.bodyFontFamily}&header_alignment=${item.headerAlignment}&header_font_size=${item.headerFontSize}&header_font_family=${item.headerFontFamily}&footer_alignment=${item.footerAlignment}&footer_font_size=${item.footerFontSize}&footer_font_family=${item.footerFontFamily}&watermark=${item.watermark}&opacity=${item.opacity}`;
        if (item.download_option === 2) {
          api = "download-answer-key";
          query = `token=${token}`;
        } else if (item.download_option === 3) {
          api = "download-test-solution";
          query = `custom=${tab}&token=${token}&fontSize=${item.bodyFontSize}&fontFamily=${item.bodyFontFamily}&header_alignment=${item.headerAlignment}&header_font_size=${item.headerFontSize}&header_font_family=${item.headerFontFamily}&footer_alignment=${item.footerAlignment}&footer_font_size=${item.footerFontSize}&footer_font_family=${item.footerFontFamily}&watermark=${item.watermark}&opacity=${item.opacity}`;
        }
        let url = domainUrl + `/test/${api}/${item.data.test_id}?${query}`;
        //   alert(url);
        if (item.download_option === 2) {
          window.open(url, "_blank");
        } else {
          this.downloadTestResource(
            `test/${api}/${item.data.test_id}?${query}`,
            item.data
          );
        }
        //   alert(url);
      }
    },
    downloadTestResource(url, test) 
    {
      this.items = this.items.map((item)=>{
          if (item.id === test.id) {
            item.status = constants.DOWNLOAD_STATUS.IN_PROGRESS
          }
          return item
        })
      this.toasts[test.id] =  this.$toasted.success("PDF creation under progress. Please do not leave this page",{icon: 'info',duration: null,id: test.id.toString()})
      this.downloadTestPaper(url)
        .then((res) => {
          // console.log(res);
          this.requestIds.push(res.request_id);
          // this.$toasted.dismiss()

          this.updateRouteDetails({
            type: "requestIds",
            data: { requestIds: this.requestIds },
          });
          this.items = this.items.map((item) => {
            if (item.id === test.id) {
              item.request_id = res.request_id;
            }
            return item
          });
          this.checkDownloadUpdate();

          // this.requestGetTestList()
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkDownloadUpdate() {
      console.log(this.requestIds, "request_ids");

      if (this.testStatusTimeout) {
        clearInterval(this.testStatusTimeout);
        this.testStatusTimeout = null;
      }
      if (this.requestIds && this.requestIds.length) {
        this.testStatusTimeout = setInterval(() => {
          this.getTestDownloadStatus();
        }, 10 * 1000);
      }
    },
    getTestDownloadStatus() {
      const reqData = {
        request_ids: this.requestIds,
        download_types: [
          constants.DOWNLOAD_TYPES.TEST_PAPER,
          constants.DOWNLOAD_TYPES.SOLUTION_PAPER,
          constants.DOWNLOAD_TYPES.OMR,
        ],
      };
      this.getDownloadStatus(reqData)
        .then(async(res) => {
          const arr = [];
          
          // Map over items to update their status and collect data for download
         this.items = this.items.map((item) => {
            const data = res.find((r) => r.request_id == item.request_id);
            if (data && data.status === constants.DOWNLOAD_STATUS.COMPLETED) {
              item.url = data.url;
              item.status = data.status;
              if (item.url) {
                arr.push({
                  url: data.url,
                  request_id: data.request_id,
                });
              }

              // Remove processed request IDs
              this.requestIds = this.requestIds.filter(
                (rid) => rid !== data.request_id
              );
              
               // Remove toast notifications
              if (this.toasts[item.id]) {
                delete this.toasts[item.id];
              }
              if (this.toasts[item.test_id]) {
                this.toasts[item.test_id].goAway(0);
              }

              // Show success toast
              this.$toasted.success(
                `Your ${data.download_type} of ${item.test_name} PDF is successfully downloaded`,
                { icon: "info" }
              );
              // Update route details
              this.updateRouteDetails({
                type: "requestIds",
                data: { requestIds: this.requestIds },
              });
            }
            return item
          });
          // Sequentially download files with a delay
          for (let i = 0; i < arr.length; i++) {
            const item = arr[i];
            await this.downloadTestURL(item); // Download the file

            // Add a delay of 1 second
            await new Promise((resolve) => {
              setTimeout(() => {
                resolve();
              }, 1000);
            });
          }

          // Clear the interval if there are no remaining request IDs
          if (!this.requestIds || !this.requestIds.length) {
            clearInterval(this.testStatusTimeout);
            this.testStatusTimeout = null;
          }
        })
        .catch((err) => {});
    },
    downloadTestURL(item) {
      console.log(item);

      if (item.url && item.request_id) {
        window.open(item.url, "_self");
        const reqData = {
          request_id: item.request_id,
        };
        this.deleteDownloadData(reqData)
          .then((res) => {
            this.items =this.items.map((data)=>{
                if (data.request_id==item.request_id) {
                    
                    data.status = null;
                    data.request_id = null;
                    data.url = null;
                }
                return data
            })
            this.$forceUpdate()
          })
          .catch((err) => {});
      }
    },
    getSubjects() {
      let reqData = {
        level: 2,
      };
      this.selectedSubject = null;
      this.$root.showLoader = true;
      this.getDataTreeWithLevel(reqData)
        .then((response) => {
          this.$root.showLoader = false;
          this.subjects = response.filter((res, i) =>
            this.teacherSubjectId.includes(res.id)
          );

          this.selectedSubject = this.subjects[0].id;
          this.requestGetTestList();
          this.getHeaders();
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    getTeacherSubjectTree() {
      this.getTeacherSubject()
        .then((response) => {
          this.teacherSubjectId = response;
          this.getSubjects();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onChangeSubject() {
      this.getHeaders();
      this.requestGetTestList();
    },
    onSearchTest() {
      this.resetFields();
      this.requestGetTestList();
      // this.updateRouteDetails({ searchText: this.testName });
    },
    resetFields() {
      this.currentPage = 1;
      this.pageSize = 10;
      this.totalPages = 1;
    },
    getFormatedDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getFormatedTime(date) {
      return moment(date).format("hh:mm A");
    },
    gotoPastTest(item) {
      localStorage.setItem("previousRoute", this.$route.name);
      localStorage.setItem("previousPath", this.$route.path);
      this.$router.push({
        name: "past-tests-preview",
        params: {
          test_id: item.test_id,
          test_institute_id: item.test_institute_id,
        },
      });
    },
    requestGetTestList() {
      let reqData = {
        type: "INSTITUTE",
        // test_types: [this.TEST_TYPE.PAST_TEST],
        subject_id: this.selectedSubject,
        orderBy: this.orderBy,
        search_query: this.testName,
        test_name: null,
        pagination: { page: this.currentPage, pageSize: this.pageSize },
      };
      if (this.selectedCenterId.length > 0) {
        reqData.center_id = this.selectedCenterId;
      }
      if (this.selectedBatch) {
        reqData.batch_id = this.selectedBatch;
      }

      this.$root.showLoader = true;
      this.getPastTestList(reqData)
        .then((response) => {
          if (
            response.list.length == 0 &&
            this.currentPage != 1 &&
            !this.$route.query.resetPage
          ) {
            this.onPageChange(1);
            return;
          }
          this.$root.showLoader = false;
          this.items = response.list;
          this.totalPages = response.pagination.pageCount;
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    requestGetCenters() {
      this.centers = [];
      this.$root.showLoader = true;
      this.getCenters()
        .then((response) => {
          this.$root.showLoader = false;
          this.centers = response.map((x, i) => {
            let c = {};
            c.text = x.name;
            c.value = x.id;
            return c;
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });
    },
    onCenterchange(centerIds) {
      this.selectedCenterId = centerIds;
      this.onCenterSelect(centerIds);
      this.requestGetTestList();
    },
    onselectedBatch(batch_id) {
      this.selectedBatch = batch_id;
      this.requestGetTestList();
    },

    onCenterSelect(centerId) {
      this.batches = [];
      if (centerId.length) {
        this.getBatches({ center_id: centerId })
          .then((response) => {
            this.loading = false;
            this.batches = response.list.map((x) => {
              let c = {};
              c.text = x.name;
              c.value = x.id;
              return c;
            });
          })
          .catch((err) => {
            this.loading = false;
          });
      }
    },

    onPageChange(e) {
      this.currentPage = e;
      this.requestGetTestList();
    },
    onSortChange() {
      this.requestGetTestList();
    },
    onHeaderAction(e) {
      if (e.data && e.data.selectedItems) {
        this.selectedExamTypes = e.data.selectedItems;
        let routeName = this.$route.name;
        console.log(routeName,"onHeaderAction");
        
        let crd = this.getCurrentRouteDetails(routeName);
        crd.tabDetails[crd.selectedTab].examTypes = e.data.selectedItems;
        this.setRouteDetails(crd);
        this.onPageChange(1);
      }
    },

    updateRouteDetails(details) {
      let routeName = this.$route.name;
      console.log(routeName,"updateRouteDetails");
      
      let crd = this.getCurrentRouteDetails(routeName);
      switch (details.type) {
        case "requestIds":
          crd.tabDetails[crd.selectedTab].requestIds = details.data.requestIds;
          break;
        default:
          break;
      }
      this.setRouteDetails(crd);
    },
  },

  beforeDestroy() {
    clearInterval(this.testStatusTimeout);
    this.testStatusTimeout = null;
  },
};
</script>
